// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__1YtVF","list_button":"styles_list_button__ojlnz","button-content":"styles_button-content__3sY_A"};